import { useContext, useState } from "react";
import { TeamsFxContext } from "../context/Context";
import { useParams, Link } from "react-router-dom";
import { Box, CircularProgress, Container, TextField, Typography, useTheme } from "@mui/material";
import { Colors } from "../components/style";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { lightBlue } from '@mui/material/colors';
import { gray } from "../shared-theme/themePrimitives";

const Chat = () => {
  const { apiUrl } = useContext(TeamsFxContext);
  const { ticketId, operator_id } = useParams();
  const theme = useTheme();

  const [loading, setLoading] = useState(true);

  const iframeSrc = "https://mapei.aion-asa.com/?chat_id=" + ticketId + "&ticket_id=" + ticketId + "&theme=" + theme.palette.mode + "&operator_id=" + operator_id;
  // const iframeSrc = "http://localhost:3001/?chat_id=" + ticketId + "&ticket_id=" + ticketId + "&theme=" + theme.palette.mode;

  
  console.log("IFRAME SRC", iframeSrc)

  return (
    <Box sx={{ paddingTop: "1rem", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
      <Link to={"/Dashboard"}
        style={{
          textTransform: "none",
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ArrowBackIosRoundedIcon sx={{ color: Colors.white }} />
        <Typography
          variant='h6'
          color={Colors.white}
          sx={{
            fontWeight: "bold",
            marginLeft: "0.5rem",
            textTransform: "none"
          }}>
          Indietro
        </Typography>
      </Link>

      <Box
        sx={{
          position: "relative",
          height: "90vh",
          width: "100%",
          borderColor: Colors.red,
          borderWidth: "20px",
        }}
      >
        {/* Mostra il loader mentre l'iframe è in caricamento */}
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
              color: "#FFF"
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        )}

        <iframe
          id="showChat"
          src={iframeSrc}
          onLoad={() => setLoading(false)}
          style={{
            width: '100%',
            height: '100%',
            border: '0px solid red',
            background: theme.palette.mode === 'dark' ? gray[800] : lightBlue[900],
          }}
          title="Chat Frame"
          seamless="seamless"
        />
      </Box>
    </Box>
  );
};

export default Chat;
